import posed from 'react-pose';

const DivWrapper = posed.div({
    enter: { x: 0, opacity: 1 },
    exit: { x: 0, opacity: 1 }
});

export default DivWrapper;


// WEBPACK FOOTER //
// ./src/components/DivWrapper.js